import { lightTheme } from '@/customTheme'

function NewSectionIcon({
  size = 24,
  fill = lightTheme.colors.blackGray,
}: {
  size?: number
  fill?: string
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x={3} y={4} width={18} height={6} rx={2} stroke={fill} strokeWidth={2} />
      <rect x={3} y={14} width={18} height={6} rx={2} stroke={fill} strokeWidth={2} />
    </svg>
  )
}

export default NewSectionIcon
